export default function PrivacyPolicy() {
  return (
    <div className="max-w-5xl mx-auto p-6 md:p-10 text-gray-700">
      <h1 className="text-3xl font-heading text-palmGreen mb-6">
        Privacy Policy – Flyteo.in
      </h1>

      <p className="mb-6">
        Flyteo.in (“Company”, “we”, “our”, or “us”) is committed to protecting the
        privacy and security of your personal information. This Privacy Policy
        explains how we collect, use, disclose, and safeguard your data when you
        visit Flyteo.in or use our services, including hotel bookings, room
        bookings, villas, camping, and adventure activity reservations.
      </p>

      <p className="mb-6">
        By using our website or services, you agree to the terms outlined in this
        Privacy Policy.
      </p>

      {/* SECTION 1 */}
      <h2 className="text-2xl font-semibold mt-8 mb-4">
        1. Information We Collect
      </h2>

      <h3 className="font-semibold mb-2">1.1 Personal Information</h3>
      <ul className="list-disc ml-6 space-y-1">
        <li>Full name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Address (optional or billing-related)</li>
        <li>
          Government ID (only when required by law for bookings or check-ins)
        </li>
        <li>
          Payment details (processed securely via third-party gateways; we do not
          store full card information)
        </li>
      </ul>

      <h3 className="font-semibold mt-4 mb-2">
        1.2 Booking & Travel Information
      </h3>
      <ul className="list-disc ml-6 space-y-1">
        <li>Check-in and check-out dates</li>
        <li>Hotel, villa, or room preferences</li>
        <li>Camping or adventure activity selections</li>
        <li>Number of guests</li>
        <li>Special requests (if provided)</li>
      </ul>

      <h3 className="font-semibold mt-4 mb-2">
        1.3 Automatically Collected Information
      </h3>
      <ul className="list-disc ml-6 space-y-1">
        <li>IP address</li>
        <li>Device type</li>
        <li>Browser type</li>
        <li>Operating system</li>
        <li>Pages visited and actions on our website</li>
        <li>Cookies and tracking pixels (to improve site performance)</li>
      </ul>

      {/* SECTION 2 */}
      <h2 className="text-2xl font-semibold mt-10 mb-4">
        2. How We Use Your Information
      </h2>

      <ul className="list-disc ml-6 space-y-2">
        <li>To process and confirm bookings</li>
        <li>
          To communicate booking updates, confirmations, or support messages
        </li>
        <li>To personalize your experience and improve our services</li>
        <li>To prevent fraud or unauthorized transactions</li>
        <li>To comply with legal, regulatory, or security requirements</li>
        <li>To send promotional offers (only if you opt-in)</li>
      </ul>

      {/* SECTION 3 */}
      <h2 className="text-2xl font-semibold mt-10 mb-4">
        3. Sharing of Your Information
      </h2>

      <p className="mb-2">
        We do not sell your personal data. We may share information only with:
      </p>

      <h3 className="font-semibold mb-2">3.1 Service Providers</h3>
      <ul className="list-disc ml-6 space-y-1">
        <li>Hotels, villas, and accommodation partners</li>
        <li>Camping and adventure activity providers</li>
        <li>Payment gateways</li>
        <li>Customer service and support vendors</li>
        <li>IT and analytics service providers</li>
      </ul>

      <h3 className="font-semibold mt-4 mb-2">3.2 Legal Authorities</h3>
      <ul className="list-disc ml-6 space-y-1">
        <li>Law enforcement agencies</li>
        <li>Court orders</li>
        <li>Government or regulatory authorities</li>
      </ul>

      {/* SECTION 4 */}
      <h2 className="text-2xl font-semibold mt-10 mb-4">
        4. Cookies & Tracking Technologies
      </h2>

      <p className="mb-2">Flyteo.in uses cookies to:</p>
      <ul className="list-disc ml-6 space-y-1">
        <li>Enhance user experience</li>
        <li>Analyze website performance</li>
        <li>Remember user preferences</li>
        <li>Provide relevant offers</li>
      </ul>

      <p className="mt-2">
        You can modify your browser settings to decline cookies if desired.
      </p>

      {/* SECTION 5 */}
      <h2 className="text-2xl font-semibold mt-10 mb-4">
        5. Data Security
      </h2>

      <p className="mb-2">
        We implement strong security measures, including:
      </p>
      <ul className="list-disc ml-6 space-y-1">
        <li>SSL encryption</li>
        <li>Secure servers</li>
        <li>Limited employee access</li>
        <li>Regular security audits</li>
      </ul>

      <p className="mt-2">
        While we strive to protect your information, no online method of
        transmission is 100% secure.
      </p>

      {/* SECTION 6 */}
      <h2 className="text-2xl font-semibold mt-10 mb-4">
        6. Your Rights
      </h2>

      <p className="mb-2">You may request:</p>
      <ul className="list-disc ml-6 space-y-1">
        <li>Access to your personal data</li>
        <li>Correction of inaccurate information</li>
        <li>Deletion of your data (where applicable)</li>
        <li>Opt-out from marketing communications</li>
      </ul>

      <p className="mt-2">
        To exercise your rights, contact us at{" "}
        <strong>flyteotravels@gmail.com</strong>.
      </p>

      {/* SECTION 7 */}
      <h2 className="text-2xl font-semibold mt-10 mb-4">
        7. Third-Party Links
      </h2>

      <p>
        Our website may include links to external websites. Flyteo.in is not
        responsible for their privacy practices. Please review their policies
        before interacting with them.
      </p>

      {/* SECTION 8 */}
      <h2 className="text-2xl font-semibold mt-10 mb-4">
        8. Children’s Privacy
      </h2>

      <p>
        We do not knowingly collect personal information from anyone under 18
        years of age. If such data is discovered, it will be deleted promptly.
      </p>

      {/* SECTION 9 */}
      <h2 className="text-2xl font-semibold mt-10 mb-4">
        9. Updates to This Privacy Policy
      </h2>

      <p>
        We may revise this Privacy Policy from time to time. Updated versions
        will be posted on this page with a new “28 DEC 2025” date.
      </p>

      {/* SECTION 10 */}
      <h2 className="text-2xl font-semibold mt-10 mb-4">
        10. Contact Us
      </h2>

      <p className="font-semibold">Flyteo.in – Privacy Department</p>
      <p>📧 Email: flyteotravels@gmail.com</p>
      <p>📞 Phone: 8975995125</p>
    </div>
  );
}
